/**
 * INCENTIVE-TRACKER MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 *
 * Public entry point. The app composition root (App.jsx / registry.jsx) imports
 * ONLY from here; nothing deep-imports this module's internals.
 */
import IncentivePrograms from "./routes/IncentivePrograms.jsx";
import IncentiveProgram from "./routes/IncentiveProgram.jsx";
import IncentiveDistributorProgress from "./routes/IncentiveDistributorProgress.jsx";
import { getDashboardSummary } from "./utils/dashboardSummary.js";

// `/incentives/progress` is a static segment and so outranks the
// `/incentives/:programId` pattern in React Router v6 — order here is
// irrelevant, the ranking is what keeps them apart.
export const incentiveTrackerRoutes = [
  { path: "/incentives", component: IncentivePrograms },
  { path: "/incentives/progress", component: IncentiveDistributorProgress },
  { path: "/incentives/progress/:distributor", component: IncentiveDistributorProgress },
  { path: "/incentives/:programId", component: IncentiveProgram },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "incentive-tracker", label: "Incentive Tracker" };

// Operations-hub (Home) contribution — programs needing review / scoring.
// Collected automatically by the composition root.
export const dashboardProvider = getDashboardSummary;
